import React from "react";
import copyToClipboard from "copy-to-clipboard";

export const useClipboard = (value: string) => {
  const [hasCopied, setHasCopied] = React.useState(false);

  const onCopy = () => {
    const didCopy = copyToClipboard(value);
    if (value && didCopy) {
      setHasCopied(true);
      setTimeout(() => setHasCopied(false), 1500);
    }
  };

  return { onCopy, hasCopied, value };
};
